import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginModal.css";

const LoginModal = ({ isOpen, onClose, onLoginSuccess }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Static login credentials
    const validEmail = "admin@cpit.com";
    const validPassword = "admin123";

    // Check if credentials match
    if (email === validEmail && password === validPassword) {
      // Call success callback to update auth state
      if (onLoginSuccess) {
        onLoginSuccess();
      }
      
      // Navigate to dashboard
      navigate("/dashboard");
      
      // Reset form
      setEmail("");
      setPassword("");
    } else {
      alert("Invalid credentials! Please try again.\n\nDemo Credentials:\nEmail: admin@cpit.com\nPassword: admin123");
    }
  };

  const handleClose = () => {
    setEmail("");
    setPassword("");
    onClose();
  };

  return (
    <div className="login-overlay" onClick={handleClose}>
      <div className="login-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={handleClose}>✕</button>

        <h2 className="login-title">Welcome Back</h2>
        <p className="login-subtitle">Please login to your account</p>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input 
              type="email" 
              required 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <label>Email Address</label>
          </div>

          <div className="input-group">
            <input 
              type="password" 
              required 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <label>Password</label>
          </div>

          <button type="submit" className="login-submit-btn">
            Login
          </button>
        </form>

        <div className="login-info">
          <p style={{ fontSize: '12px', color: '#666', marginTop: '15px' }}>
            Demo Credentials:<br />
            Email: admin@cpit.com<br />
            Password: admin123
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;